import { FleetNavigationModule } from "@app/main/modules/fleet/fleet.navigation";
import { AccountFeatures } from "@enums/account/AccountFeature";
import { AuthorizationService } from "@services/authorization.service";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { GroupMessageController } from "./groupMessage.controller";
import { MessagingController } from "./messaging.controller";
import { MessagingConversationComponent } from "./messagingConversation.component";
import { MessageService } from "./service/messaging.service";

export class Config {

    static $inject = ["$stateProvider"];

    constructor($stateProvider: StateProvider) {

        $stateProvider.state(FleetNavigationModule.Messages, {
            url: "/messages/:vehicle",
            views: {
                "content@app": {
                    template: require("./messaging.html"),
                    controller: "messagingController as $ctrl"
                }
            },
            params: {
                vehicle: { squash: true, value: null },
            },
            data: { translation: "Common.Messages" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([], [
                    AccountFeatures.Messaging
                ])]
            }
        });
    }
}

angular
    .module("app.components.messaging", [
        "ui.router",
        "app.components.util.api"
    ])
    .config(Config)
    .controller("GroupMessageController", GroupMessageController)
    .controller("messagingController", MessagingController)
    .component("messagingConversation", new MessagingConversationComponent())
    .service("messageService", MessageService);
